import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class PaymentGrid extends BaseComponent {
	
	static get properties() {
		return {
			user: {type: Boolean}
		};
	}
	
	constructor() {
		super();		
		
		var paymentGrid = this;
		setTimeout(function(){
			paymentGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var paymentGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},	
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Filter Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startYearInPast());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'Filter End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());	
					}()
				},
				{
					tag: 'span',
					itemid: 'separator1',
					'class': 'spacer-toolbar-item',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},				
				{
					tag: 'dl-action-button',
					itemid: 'recordPayment',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:cash', ' Record Payment')
					],
					listeners: {
						click: function() {							
							actionRecordPayment();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'creditAccount',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:minus', ' Credit Account')
					],
					listeners: {
						click: function() {							
							actionCreditAccount();
						}
					}					
				},
				{
					tag: 'span',
					itemid: 'separator2',
					'class': 'spacer-toolbar-item',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'view',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:READ', 'COMPANY_ACCOUNT_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:bullets', ' View Details')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}					
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [					
				{						
					path: 'paymentRecord',
					header: 'Type',						
					width: '9em',				
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.paymentRecord ? 'Payment' : 'Credit';
					}
				},		
				{						
					path: 'createDts',
					header: 'Date',						
					width: '9em',				
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.createDts);						
						root.innerHTML = TimeUtil.formatDateOnlyStandard(date);						
					}
				},
				{						
					path: 'paymentType',
					header: 'Payment Type',						
					width: '9em',					
					renderer: function(root, column, rowData) {												
						root.innerHTML = rowData.item.paymentRecord ? rowData.item.payment.paymentType : rowData.item.credit.paymentType;					
					}
				},
				{						
					path: 'paymentAmt',
					header: 'Amount',
					'text-align': 'end',
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(
							rowData.item.paymentRecord ? rowData.item.payment.paymentAmt : rowData.item.credit.creditAmt	
						);
					}
				},		
				{						
					path: 'confirmationNo',
					header: 'Confirmation No',
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.paymentRecord ? rowData.item.payment.confirmationNo : rowData.item.credit.confirmationNo;
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'view').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;
					}
				}
			}
		});		
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'payments',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		paymentGrid.append(flexLayout);		
		
		if (paymentGrid.user) {			
			ElementUtil.query(toolbar, 'separator1').classList.add('hide');
			ElementUtil.query(toolbar, 'separator2').classList.add('hide');
			
			//The button need to be inited before this can take affect
			setTimeout(function(){
				ElementUtil.query(toolbar, 'recordPayment').classList.add('hide');
				ElementUtil.query(toolbar, 'creditAccount').classList.add('hide');
			}, 100);			
		}		
		
		var actionRefresh = function() {
			
			var startDate = ElementUtil.query(toolbar, 'filterStartDate').value;
			var endDate = ElementUtil.query(toolbar, 'filterEndDate').value;			
			
			var options = {
				startDate: startDate,
				endDate: endDate
			};			
			
			var loadMask = paymentGrid.showLoading();
			BillingService.getAccountService().getPayments(paymentGrid.detail.companyId, options)
			.then(function(payments){							
				loadMask.remove();
				grid.activeItem = null;	
				payments = payments.sort(function(a, b){
					var bDate = new Date(b.createDts);
					var aDate = new Date(a.createDts);
					return TimeUtil.compare(bDate, aDate);
				});
				
				grid.items = payments;
			});
		};
		actionRefresh();
		
		var actionRecordPayment = function() {
			var paymentWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Record Payment',
				icon: 'vaadin:cash',
				width: .75,
				height: 350,
				listeners: {
					ready: function() {						
						paymentWin.show();
									
						var tchAccount;
						
						//form
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [																				
										{
											tag: 'vaadin-combo-box',
											itemid: 'paymentType',
											label: 'Payment Type', 
											name: 'paymentType',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												
												var paymethods = [];
												paymethods.push({
													code: 'CHK',
													description: 'Check'
												});																						
												
												BillingService.getAccountService().getAccountCurrentPaymethod(paymentGrid.detail.companyId).then(function(payInfo){
													if (payInfo.tchAccount){
														tchAccount = payInfo.tchAccount;
														paymethods.push({
															code: 'TCH',
															description: 'TCH'
														});
													}
													
													combo.items = paymethods;
												});
												
											}
										},
										{
											tag: 'vaadin-text-field',
											label: 'Reference No',
											name: 'referenceNo',											
											required: true,
											maxlength: 80
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Applied Date',
											name: 'appliedDate',	
											value: TimeUtil.formatDateForDateTimeLoad(new Date()),
											required: true
										},
										{
											tag: 'vaadin-text-field',
											label: 'Memo',
											name: 'memo',
											maxlength: 1024
										},									
										{
											tag: 'vaadin-number-field',
											label: 'Charge Amount',
											name: 'amount',
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-number-field',
											itemid: 'confirmAmount',
											label: 'Confirm Amount',											
											name: 'confirmAmount',
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-checkbox',									
											name: 'updateReferalBalance',
											colspan: 2,
											checked: true,
											label: 'Update Referral Balance'	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Record')
													],
													listeners: {
														click: function() {															
															
															var paymentData = formPanel.getData();
															if (paymentData.confirmAmount !== paymentData.amount) {
																window.DL.MessageUtil.showToastError("Charge Amount and Confirm Amount must match.");																
																var errorMessage = ElementUtil.query(formPanel, 'confirmAmount');
																errorMessage.errorMessage = 'Check Value';
																errorMessage.invalid = true;
																return;
															}															
																
															formPanel.submitForm({
																preSubmit: function(data) {	
																	
																	data.companyId = paymentGrid.detail.companyId,
																	data.credit = false;
																	if (data.paymentType === 'CHK') {
																		data.checkInfo = {
																			companyId: paymentGrid.detail.companyId,																			
																			chargeAmount: data.amount,
																			checkNo: data.referenceNo,
																			memo: data.memo,
																			checkClearDate: data.appliedDate
																		};
																	} else if (data.paymentType === 'TCH') {
																		data.tchInfo = {
																			companyId: paymentGrid.detail.companyId,																		
																			chargeAmount: data.amount,
																			account: tchAccount,																		
																			confirmationNumber: data.referenceNo,
																			memo: data.memo,
																			appliedDate: data.appliedDate,
																			contractId: tchAccount.contractNo																																					
																		};
																	}																	
																	
																	return data;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().postPaymentCredit(paymentGrid.detail.companyId, data);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Applied Payment', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																	
																	actionRefresh();
																	paymentWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															paymentWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						paymentWin.addToContentElement(formPanel);											
						
					}
				}
			});
			
		};
		
		var actionCreditAccount = function() {
			
			var creditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Credit Account',
				icon: 'vaadin:minus',
				width: .75,
				height: 600,
				listeners: {
					ready: function() {						
						creditWin.show();
						
						var products = [];
						var productGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'productCode',
									header: 'Product Code',					
									width: '7em',
									renderer: function(root, column, rowData) {
										root.innerHTML = rowData.item.productCode + '-' + rowData.item.featureProductCode;
									}
								},
								{
									path: 'description',
									header: 'Product Description',					
									'flex-grow': '1'
								},
								{						
									path: 'amount',
									header: 'Amount',					
									width: '7em',
									'text-align': 'end',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.amount);
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									productGrid.selectedItems = item ? [item] : [];
									if (productGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'removeItem').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'removeItem').disabled = true;
									}	
								}
							}
						});
						
						var tchAccount;												
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [																				
										{
											tag: 'vaadin-combo-box',
											itemid: 'paymentType',
											label: 'Apply To', 
											name: 'paymentType',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												
												var paymethods = [];
												paymethods.push({
													code: 'CHK',
													description: 'Check'
												});																						
												
												BillingService.getAccountService().getAccountCurrentPaymethod(paymentGrid.detail.companyId).then(function(payInfo){
													if (payInfo.tchAccount){
														tchAccount = payInfo.tchAccount;
														paymethods.push({
															code: 'TCH',
															description: 'TCH'
														});
													}
													
													combo.items = paymethods;
												});
												
											}
										},
										{
											tag: 'vaadin-text-field',
											label: 'Reference No',
											name: 'referenceNo',											
											required: true,
											maxlength: 80
										},									
										{
											tag: 'vaadin-text-field',
											label: 'Reason',
											name: 'memo',
											maxlength: 1024
										},																			
										{
											tag: 'vaadin-checkbox',									
											name: 'updateReferalBalance',										
											checked: true,
											label: 'Update Referal Balance'	
										},
										{
											tag: 'dl-section-title',
											title: 'Products',
											colspan: 2,
											style: 'margin-top: 20px;'											
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'height: 275px;',								
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'addItem',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddProduct();
																		}
																	}					
																},																	
																{
																	tag: 'vaadin-button',
																	itemid: 'removeItem',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveProduct(productGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														productGrid,
														{
															tag: 'div',
															itemid: 'total',
															slot: 'footer',
															trustedInnerHTML: true,
															innerHTML: 'Total Credit: <b>$0</b>'
														}
													]
												}
											]										
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {																														
														
															if (products.length <= 0) {
																window.DL.MessageUtil.showToastError("Must have at least one product.");																																
																return;
															}															
																
															formPanel.submitForm({
																preSubmit: function(data) {	
																	
																	data.creditItems = [];
																	var totalAmount = 0;
																	products.forEach(function(product){
																		totalAmount += parseFloat(product.amount);
																		data.creditItems.push({
																			productCode: product.productCode,
																			featureCode: product.featureProductCode,
																			amount: parseFloat(product.amount)
																		});
																	});
																	
																	data.companyId = paymentGrid.detail.companyId,
																	data.credit = true;
																	data.creditReason = data.memo;
																	data.amount = totalAmount;
																	data.appliedDate = (new Date()).toISOString();
																	if (data.paymentType === 'CHK') {
																		data.checkInfo = {
																			companyId: paymentGrid.detail.companyId,																			
																			chargeAmount: totalAmount,
																			checkNo: data.referenceNo,
																			memo: data.memo,
																			checkClearDate: (new Date()).toISOString()
																		};
																	} else if (data.paymentType === 'TCH') {
																		data.tchInfo = {
																			companyId: paymentGrid.detail.companyId,																		
																			chargeAmount: totalAmount,
																			account: tchAccount,																		
																			confirmationNumber: data.referenceNo,
																			memo: data.memo,
																			appliedDate: (new Date()).toISOString(),
																			contractId: tchAccount.contractNo																																					
																		};
																	}	
																																
																	return data;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().postPaymentCredit(paymentGrid.detail.companyId, data);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Applied Payment', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																	
																	actionRefresh();
																	creditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															creditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						creditWin.addToContentElement(formPanel);											
						
						var actionRefreshProducts = function() {
							productGrid.activeItem = null;
							productGrid.items = products.slice(0);
							updateTotalCredit();
						};
						
						var actionAddProduct = function() {
					
							var addWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add product',
								icon: 'vaadin:minus',
								width: 450,
								height: 250,
								listeners: {
									ready: function() {						
										addWin.show();
								
										var addFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																				
														{
															tag: 'vaadin-combo-box',
															itemid: 'product',
															label: 'Product', 
															name: 'product',
															required: true,
															'item-value-path': 'code',
															'item-label-path': 'description',
															postinit: function(combo) {

																BillingService.getAccountService().getOrders(paymentGrid.detail.companyId).then(function(orders){
																	var items = [];
																	
																	orders.forEach(function(order){
																		order.items.forEach(function(itemFull){
																			items.push({
																				itemFull: itemFull,
																				code: itemFull.item.productCode + '-' + itemFull.item.featureProductCode,
																				description: itemFull.itemDesc
																			});
																		});																	

																	});
																	
																	combo.items = items;
																});

															}
														},
														{
															tag: 'vaadin-number-field',
															label: 'Amount',
															name: 'amount',											
															required: true,
															maxlength: 80
														},									
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {																														
																			
																			var data = addFormPanel.getData();																			
																			if (addFormPanel.isValid()) {
																				var productSelection = ElementUtil.query(addFormPanel, 'product').selectedItem;
																				
																				products.push({
																					productCode: productSelection.itemFull.item.productCode,
																					featureProductCode:	productSelection.itemFull.item.featureProductCode,
																					description: productSelection.itemFull.itemDesc,
																					amount: data.amount																					
																				});
																				
																				actionRefreshProducts();	
																				addWin.close();
																			} 																			
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addWin.addToContentElement(addFormPanel);	
										
									}
								}
							});							
						};
						
						var actionRemoveProduct = function(existingProduct) {
							var newItems = [];
							products.forEach(function(item){
								if (!(item.productCode === existingProduct.productCode  
									&& item.featureProductCode === existingProduct.featureProductCode)) {
									newItems.push(item);
								}
							});	
							products = newItems;
							actionRefreshProducts();							
						};
						
						var updateTotalCredit = function() {
							var totalAmount = 0;
							products.forEach(function(product){
								totalAmount += product.amount;
							});							
							
							ElementUtil.query(formPanel, 'total').innerHTML = 'Total Credit: <b>' + 
									StringUtil.currencyFormat(totalAmount) + 
									'</b>';
						};
												
					}
				}
			});			
		};
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Payment Details',
				icon: 'vaadin:cash',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						viewWin.show();
					
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});	

						var viewFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								detailTable
							]
						});							
						
						viewWin.addToContentElement(viewFlexLayout);
						
						
						//load details
						var id = record.paymentRecord ? record.payment.paymentId : record.credit.creditId;
						BillingService.getAccountService().getPayment(paymentGrid.detail.companyId, id).then(function(detail){

							var data = [											
								{
									key: 'Processing Company Code',
									value: detail.invoiceControl.processingCompanyCode
								},
								{
									key: 'Transmition Date',
									value:  TimeUtil.formatDateStandard(detail.invoiceControl.transmitDts)
								},
								{
									key: 'Success Amount',
									value: StringUtil.currencyFormat(detail.invoiceControl.successAmt)
								},
								{
									key: 'Failed Amount',
									value: StringUtil.currencyFormat(detail.invoiceControl.failAmt)
								},
								{
									key: 'invoiceNo',
									value: detail.invoiceControlItem.invoiceNo
								},
								{
									key: 'Payment Type',
									value: detail.invoiceControlItem.paymentType
								},
								{
									key: 'Process Status',
									value: detail.invoiceControlItem.processingStatusInd
								},
								{
									key: 'Additional Details',
									value: function() {
										var props = [];										
										for (var key in detail.viewProperties) {
											props.push('<b>' + key + '</b>: ' + detail.viewProperties[key]);
										}			
										if (props.length > 0) {
											return props.join('<br>');
										} else {
											return 'N/A';
										}
									}()
								}
							];	

							detailTable.updateDetails(data);														
							
						});
												
					}
				}
			});
			
		};		
		
	}
	
};
customElements.define('dl-account-payment-grid', PaymentGrid);